<template>
    <div class="product-attributes" v-if="getAttributes && getStep"
         :class="{ 'slim' : getStep.id === 'pa_additionals' || getStep.id === 'pa_materac'}">
      <transition enter-active-class="animate__animated animate__faster animate__fadeIn">
        <Arrangement v-if="getStep.id === 'pa_uklad' && getAttributes.hasOwnProperty('pa_uklad')"
                     :attributes="getAttributes.pa_uklad" step="pa_uklad"/>
        <ColorFabric v-if="getStep.id === 'pa_tkanina' && getAttributes.hasOwnProperty('pa_tkanina')"
                     :attributes="getAttributes.pa_tkanina" step="pa_tkanina"/>

        <Additionals v-for="item in getNormalSteps" v-if="getStep.id === item"
                     :attributes="getAttributes[item]" :step="item" :key="item"/>

        <ProductRelatedBed v-if="getStep.id === 'pa_materac'" />

      </transition>


      <ProductRelated v-if="getStep.id === 'pa_additionals' && getProduct && getProduct.product.related"
                      :products="getProduct.product.related"/>
    </div>
</template>

<script>
import Arrangement from "../customizer/attributes/Arrangement";
import ColorFabric from "./attributes/ColorFabric";
import Additionals from "./attributes/Additionals";
import ProductRelated from "./ProductRelated";
import ProductRelatedBed from "./ProductRelatedBed";

import {mapGetters, mapMutations} from "vuex";

export default {
  name: "ProductAttributes",
  components: {Arrangement, ColorFabric, Additionals, ProductRelated, ProductRelatedBed},
  watch: {
    getAttributes(n) {
      if (!n) {
        return
      }
      this.setTotalSteps(this.getTotalSteps)
      // this.getURLArguments()
    },
    getProduct(n) {
      if (n) {
        // this.setProduct(n)
      }
    }
  },
  computed: {
    ...mapGetters({
      getAttributes: 'customizer/getAttributes',
      getProduct: 'customizer/getProduct',
      getOptions: 'customizer/getOptions',
      getStep: 'customizer/getStep',
      getSteps: 'customizer/getSteps',
      getTotalSteps: 'customizer/getTotalSteps'
    }),
    getTotalSteps() {
      if (!this.getAttributes) {
        return
      }
      return Object.keys(this.getAttributes).length + 1
    },
    getNormalSteps() {
      const allowed = ['pa_uklad', 'pa_tkanina'];
      return Object.keys(this.getAttributes).filter(key => !allowed.includes(key))
    },
    // getProduct() {
    //   if (!this.getVariations || !this.getSteps) {
    //     return
    //   }
    //
    //   if (!this.getVariations || !this.getVariations.hasOwnProperty('variations')) {
    //     return
    //   }
    //
    //   // const stepIndex = this.getSteps.findIndex(step => step.id === this.getStep.id)
    //   //
    //   // const stepsBefore = stepIndex === 0 ? [this.getSteps[0].id] : this.getSteps.slice(0, stepIndex + 1).map(item => item.id)
    //
    //   let options = JSON.parse(JSON.stringify(this.getOptions))
    //
    //
    //   let values = {}
    //
    //   // stepsBefore.forEach((key, item) => {
    //   //   if (options.hasOwnProperty(key)) {
    //   //     values[key] = options[key]
    //   //   }
    //   // })
    //
    //   delete options.group
    //   delete options.pa_additionals
    //
    //   for (let prop in options) {
    //     if (options[prop] === null || options[prop] === undefined || options[prop].length === 0) {
    //       delete options[prop]
    //     }
    //   }
    //
    //   const results = this.getVariations.variations.filter((item) => {
    //     for (const x in options) {
    //       if (!item.attributes[x]) {
    //         return true
    //       }
    //       if (options[x] !== item.attributes[x]) {
    //         return false
    //       }
    //     }
    //     // for (const v in item.attributes) {
    //     //   // if (!item.attributes[v]) {
    //     //   //   return true
    //     //   // }
    //     //   if ( options[v] !== item.attributes[v]) {
    //     //     return false
    //     //   }
    //     // }
    //     return true;
    //   })
    //   if (!results.length && this.getStep.step > 1) {
    //     return {...this.getVariations.product, default: true}
    //   }
    //
    //   if (results.length) {
    //     return results[0]
    //   }
    //
    //   return this.getVariations.product
    //   // const stepsBefore =
    // },
    getProductA() {
      if (!this.getVariations || !this.getSteps) {
        return
      }

      if (!this.getVariations || !this.getVariations.hasOwnProperty('variations')) {
        return
      }

      // const stepIndex = this.getSteps.findIndex(step => step.id === this.getStep.id)
      //
      // const stepsBefore = stepIndex === 0 ? [this.getSteps[0].id] : this.getSteps.slice(0, stepIndex + 1).map(item => item.id)

      let options = JSON.parse(JSON.stringify(this.getOptions))


      let values = {}

      // stepsBefore.forEach((key, item) => {
      //   if (options.hasOwnProperty(key)) {
      //     values[key] = options[key]
      //   }
      // })

      delete options.group
      delete options.pa_additionals

      for (let prop in options) {
        if (options[prop] === null || options[prop] === undefined || options[prop].length === 0) {
          delete options[prop]
        }
      }

      const results = this.getVariations.variations.filter((item) => {
        for (const x in options) {
          if (!item.attributes[x]) {
            return true
          }
          if (options[x] !== item.attributes[x]) {
            return false
          }
        }
        // for (const v in item.attributes) {
        //   // if (!item.attributes[v]) {
        //   //   return true
        //   // }
        //   if ( options[v] !== item.attributes[v]) {
        //     return false
        //   }
        // }
        return true;
      })

      if (this.getStep.step === 1 && !this.getOptions[this.getStep.id]) {
        return this.getVariations.product
      }

      if (!results.length && this.getStep.step > 1) {
        return {...this.getVariations.product, default: true}
      }

      if (results.length) {
        return results[0]
      }

      return this.getVariations.product
      // const stepsBefore =
    },
  },
  methods: {
    ...mapMutations({
      setTotalSteps: 'customizer/setTotalSteps'
    })
  }
}
</script>

<style scoped lang="scss">
.product-attributes {
  //flex-grow: 1;
  flex: 0 0 calc(100% - (100% - 390px));

  @media (max-width: 768px) {
    flex: 0 0 calc(100% - (100% - 320px));
  }

  @media (max-width: 680px) {
    flex: 0 0 100%;
  }

  position: relative;
  overflow: hidden;
  //&:after {
  //  content: "";
  //  position: absolute;
  //  left: 0;
  //  right: 0;
  //  bottom: 0;
  //  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  //  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  //  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  //  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);
  //  height: 40px;
  //}

  &.slim {
    @media (min-width: 1024px) {
      flex: 0 0 62%;
    }
  }
}

</style>
